// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vfMtG","fullView":"styles_fullView__2JwUq"};